import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import red from '@material-ui/core/colors/red';
import toRegionAbbrev from '../../../utils/toRegionAbbrev';

const styles = (theme) => ({
	card: {
		maxWidth: 400,
	},
	media: {
		height: 0,
		paddingTop: '56.25%', // 16:9
	},
	actions: {
		display: 'flex',
	},
	expand: {
		transform: 'rotate(0deg)',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
		marginLeft: 'auto',
		[theme.breakpoints.up('sm')]: {
			marginRight: -8,
		},
	},
	expandOpen: {
		transform: 'rotate(180deg)',
	},
	avatar: {
		backgroundColor: red[500],
	},
	provinceCell: {
		width: '60px',
		padding: '12px 16px',
	},
	ratingCell: {
		width: '70px',
		textAlign: 'right',
		paddingRight: '24px',
	},
	numericCell: {
		width: '100px',
		textAlign: 'right',
		paddingRight: '24px',
	},
});

class LocationReviewDataRow extends Component {
	state = {};

	async componentDidMount() {
		const { location } = this.props;

		const { name, province, google, hasChekkit } = location;

		this.setState({ name, province, google, hasChekkit });
	}

	getLabel = (item) => {
		if (item) {
			return String(item);
		}

		return '-';
	};

	getRatingLabel = (rating) => {
		if (rating) {
			return String(rating).slice(0, 3);
		}

		return '-';
	};

	render() {
		const { _enterpriseLocation, isSelected, classes } = this.props;
		const { name, province, google, hasChekkit } = this.state;

		return google ? (
			<TableRow
				hover
				onClick={(event) =>
					this.props.handleClick(event, _enterpriseLocation, name)
				}
				role='checkbox'
				aria-checked={isSelected}
				tabIndex={-1}
				key={_enterpriseLocation}
				selected={isSelected}
			>
				<TableCell component='th' scope='row' data-column='name'>
					<Typography>
						{hasChekkit ? (
							<span style={{ fontWeight: 600 }}>{name}</span>
						) : (
							name
						)}
					</Typography>
				</TableCell>
				<TableCell
					className={classes.provinceCell}
					data-column='province'
				>
					<Typography>{toRegionAbbrev(province)}</Typography>
				</TableCell>
				<TableCell className={classes.ratingCell} data-column='rating'>
					<Typography>
						{this.getRatingLabel(google.rating)}
					</Typography>
				</TableCell>
				<TableCell
					className={classes.numericCell}
					data-column='totalReviewCount'
				>
					<div
						style={{
							display: 'inline-flex',
							flexDirection: 'row',
							alignContent: 'flex-end',
							justifyContent: 'flex-end',
							width: '100%',
						}}
					>
						<Typography>
							{this.getLabel(google.totalReviewCount)}{' '}
						</Typography>
						{google.percentChange !== '-' &&
						google.percentChange !== null &&
						google.percentChange !== undefined &&
						google.percentChange !== '' ? (
							<Typography
								variant='caption'
								gutterBottom
								align='center'
								style={{ marginTop: 2, marginLeft: 4 }}
							>
								({google.percentChange}%)
							</Typography>
						) : null}
					</div>
				</TableCell>

				<TableCell
					className={classes.numericCell}
					data-column='desktopSearchViews'
				>
					<Typography>
						{this.getLabel(google.insights.desktopSearchViews)}
					</Typography>
				</TableCell>
				<TableCell
					className={classes.numericCell}
					data-column='mobileSearchViews'
				>
					<Typography>
						{this.getLabel(google.insights.mobileSearchViews)}
					</Typography>
				</TableCell>
				<TableCell
					className={classes.numericCell}
					data-column='websiteActions'
				>
					<Typography>
						{this.getLabel(google.insights.websiteActions)}
					</Typography>
				</TableCell>
				<TableCell
					className={classes.numericCell}
					data-column='mapsViews'
				>
					<Typography>
						{this.getLabel(google.insights.mapsViews)}
					</Typography>
				</TableCell>
				<TableCell
					className={classes.numericCell}
					data-column='phoneActions'
				>
					<Typography>
						{this.getLabel(google.insights.phoneActions)}
					</Typography>
				</TableCell>
			</TableRow>
		) : (
			<TableRow
				hover
				onClick={(event) =>
					this.props.handleClick(event, _enterpriseLocation)
				}
				role='checkbox'
				aria-checked={isSelected}
				tabIndex={-1}
				key={_enterpriseLocation}
				selected={isSelected}
			>
				<TableCell component='th' scope='row' />
				<TableCell className={classes.provinceCell} />
				<TableCell className={classes.ratingCell} />
				<TableCell className={classes.numericCell} />
				<TableCell className={classes.numericCell} />
				<TableCell className={classes.numericCell} />
				<TableCell className={classes.numericCell} />
				<TableCell className={classes.numericCell} />
				<TableCell className={classes.numericCell} />
			</TableRow>
		);
	}
}

export default withStyles(styles)(LocationReviewDataRow);



// WEBPACK FOOTER //
// ./src/components/review/ReviewTable/LocationReviewDataRow.js